const getLeaseTerms = deal => deal?.leaseTerms?.filter(term => !term._destroy);

const hasLeaseTerms = deal => !!getLeaseTerms(deal)?.length;

const getLeaseTermDates = (deal) => {
  const leaseTerms = getLeaseTerms(deal);

  if (!leaseTerms?.length) return {};

  const startDate = leaseTerms[0].startDate;
  const endDate = leaseTerms[leaseTerms.length - 1].endDate;

  return { startDate, endDate };
};

const readOnlyFields = {
  leaseStartDate: {
    getUpdatedValue: deal => ({
      ...deal.leaseStartDate,
      date: getLeaseTermDates(deal).startDate,
      static: true,
    }),
    getReadOnlyStatus: hasLeaseTerms,
    readOnlyMessage: 'Please edit the Rent Schedule to update this date'
  },
  leaseExpirationDate: {
    getUpdatedValue: deal => ({
      ...deal.leaseExpirationDate,
      date: getLeaseTermDates(deal).endDate,
      static: true,
    }),
    getReadOnlyStatus: hasLeaseTerms,
    readOnlyMessage: 'Please edit the Rent Schedule to update this date'
  },
};

export const LEASE_TERM_READ_ONLY_FIELDS = ['leaseStartDate', 'leaseExpirationDate'];

export const isFieldReadOnly = (name, deal) => {
  return !!readOnlyFields[name]?.getReadOnlyStatus(deal);
};

export const getUpdatedFieldValue = (name, deal) => {
  const fieldConfig = readOnlyFields[name];
  return fieldConfig?.getUpdatedValue ? fieldConfig.getUpdatedValue(deal) : deal[name];
};

export const getFieldReadOnlyMessage = (name) => {
  const fieldConfig = readOnlyFields[name];
  return fieldConfig?.readOnlyMessage || null;
};
